import { render, staticRenderFns } from "./ShowTab.vue?vue&type=template&id=f0fc1bd4&scoped=true&"
import script from "./ShowTab.vue?vue&type=script&lang=js&"
export * from "./ShowTab.vue?vue&type=script&lang=js&"
import style0 from "./ShowTab.vue?vue&type=style&index=0&id=f0fc1bd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fc1bd4",
  null
  
)

export default component.exports